import React from "react";
import { defaultDropList, defaultAttributeList } from "../Data/WBComponentDefaults";
import { WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";

export default class BusinessReviews extends WBComponent {
    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessReviews;
        this.displayName = "Reviews";
        this.dropList = defaultDropList;
        this.editList = [componentAttributeTypes.multiLocation,"reviewsLayout", ...defaultAttributeList, attributeTypes.gap, "reviewLinkColor", "starColor", componentAttributeTypes.visibility];
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation,"reviewsLayout", componentAttributeTypes.visibility];
        this.contentEditable = false;
        this.colorFields = ["starColor","color","backgroundColor"]
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" fill="currentColor"><path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z" /></svg>
       
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
        setNodeComponentAttributeValue(thisLayout, attributeTypes.height, "600px");
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("reviewLinkColor", "Page Link Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("reviewsLayout", "Layout", "", AttributeInputType.SelectField, [
                { label: "Default", value: "default" },
                { label: "Narrow", value: "2" },
           
            ])]
       
    }
   

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const atts = GetNodeDomAttributes("flex-column  max-w-100 resizable-container clamp-height scrollable w-full vb-control", component, screenSize, isEditor);
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const layoutId = getNodeComponentAttributeValue(component, "reviewsLayout", "1");
        if (!isEditor) {
            
            return <>
    
            <BusinessPlaceHolder node={component} dataKey="reviews" layout={layoutId} classNames={atts.className} /></>
        }

        

        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                        <style>{super.GetComponentGlobalCSS(component,isEditor)}</style>
                <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layoutId} dataKey={"reviews"} node={component} userContext={siteData} />
                {/* // <RenderData component={component} atts={atts} siteData={siteData} starColor={startColor} linkColor={linkColor}/> */}
            </div>
        )
    }

}





